import RestAPI from '../../../Common/restApi';

export default class WisetackApi {
  static show() {
    return RestAPI.get('/pro/apps/wisetack_application_url');
  }
}
